import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Data, Router } from '@angular/router';
import { CmsPage } from '@app/core/models/atomics.model';
import { WindowRef } from '@shared/tools/window';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { CmsConnector } from '@app/b2b/core/cms/services/cms.connector';
import { LoaderService } from '@shared/components/loader/loader.service';
import { LOADER_TYPE } from '@shared/components/loader/loader.model';

@Injectable({
  providedIn: 'root',
})
export class PageService {
  private pageSubject = new BehaviorSubject<CmsPage | null>(null);
  private pageSubjectLoading = new BehaviorSubject<boolean>(true);

  constructor(
    private connector: CmsConnector,
    private winRef: WindowRef,
    private titleService: Title,
    private router: Router,
    private loaderService: LoaderService,
  ) {}

  get page$(): Observable<CmsPage | null> {
    return this.pageSubject.asObservable();
  }

  get pageLoading$(): Observable<boolean> {
    return this.pageSubjectLoading.asObservable();
  }

  loadPage(page: Data): void {
    const hasCMSPage = page['hasCMSPage'] ?? true;
    if (!hasCMSPage) {
      return;
    }

    this.pageSubjectLoading.next(true);
    this.loaderService.init({
      status: true,
      type: LOADER_TYPE.INFINITE,
    });

    const pageId = page['id'] || this.router.url.slice(1);
    const title = page['title'];

    if (!pageId) {
      this.pageSubjectLoading.next(false);
      this.loaderService.init({
        status: false,
        type: LOADER_TYPE.INFINITE,
      });
      return;
    }

    if (this.winRef.isBrowser()) {
      this.winRef.document.body.setAttribute('data-page-id', pageId);
    }

    this.connector
      .getPage(pageId)
      .pipe(take(1))
      .subscribe(page => {
        this.pageSubject.next(page);
        this.pageSubjectLoading.next(false);
        this.loaderService.init({
          status: false,
          type: LOADER_TYPE.INFINITE,
        });

        if (title) {
          this.titleService.setTitle(page.title ?? title);
        }
      });
  }
}
